// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArrowKeysNavigationController from "./arrow_keys_navigation_controller"
application.register("arrow-keys-navigation", ArrowKeysNavigationController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormKeyPressController from "./form_key_press_controller"
application.register("form-key-press", FormKeyPressController)

import FormSubmissionController from "./form_submission_controller"
application.register("form-submission", FormSubmissionController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import HotwireAnimationsController from "./hotwire_animations_controller"
application.register("hotwire-animations", HotwireAnimationsController)

import ModalsController from "./modals_controller"
application.register("modals", ModalsController)

import NestedLinkInButtonController from "./nested_link_in_button_controller"
application.register("nested-link-in-button", NestedLinkInButtonController)

import PortfolioAnalyzer__AssetAllocationController from "./portfolio_analyzer/asset_allocation_controller"
application.register("portfolio-analyzer--asset-allocation", PortfolioAnalyzer__AssetAllocationController)

import PortfolioAnalyzer__RiskLevelAllocationsController from "./portfolio_analyzer/risk_level_allocations_controller"
application.register("portfolio-analyzer--risk-level-allocations", PortfolioAnalyzer__RiskLevelAllocationsController)

import PortfolioAnalyzerChartController from "./portfolio_analyzer_chart_controller"
application.register("portfolio-analyzer-chart", PortfolioAnalyzerChartController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ZarazController from "./zaraz_controller"
application.register("zaraz", ZarazController)
